{
    "fallback": "nl",
    "languages": {
        "nl": { "name": "Nederlands", "status": "active", "fallback": "nl", "surfaces": ["app", "marketing", "widget", "portal", "notifications"] },
        "en": { "name": "English", "status": "active", "fallback": "nl", "surfaces": ["app", "marketing", "widget", "portal", "notifications"] }
    }
}
